import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CollapsibleSection from './CollapsibleSection';
import AssetTile from './AssetTile';

function LandingPagePicker({
    landingPages = [],
    selectLandingPage = () => { },
    deleteLandingPage = () => { },
    editLandingPage = () => { },
}) {
    const [landingPageSearch, setLandingPageSearch] = useState('');
    const [filteredLandingPages, setFilteredLandingPages] = useState(landingPages);

    const isSearching = landingPageSearch.length > 0;

    useEffect(() => {
        const filtered = landingPages.filter((landingPage) => landingPage.name.toLowerCase().includes(landingPageSearch.toLowerCase()));
        setFilteredLandingPages(filtered);
    }, [landingPages, landingPageSearch]);

    return (
        <div className="landing-page-picker margin-t-24px" style={{ minWidth: '540px' }}>
            <div className="search-field height-40px margin-b-24px">
                <label htmlFor="landing-page-picker-search" className="sr-only">Search for a Landing Page</label>
                <i className="fa fa-search"></i>
                <input
                    id="landing-page-picker-search"
                    type="text"
                    onChange={(e) => setLandingPageSearch(e.target.value)}
                    placeholder="Search for a landing page"
                />
            </div>
            {
                isSearching && <CollapsibleSection
                    title={`Search Results (${filteredLandingPages.length})`}
                    initiallyExpanded={true}
                >
                    <div className="asset-grid" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {filteredLandingPages.map((landingPage) => <AssetTile
                            key={landingPage.id}
                            asset={landingPage}
                            editable={landingPage.is_editable || false}
                            deletable={landingPage.can_delete || false}
                            legacy={false}
                            selectAsset={() => selectLandingPage(landingPage)}
                            deleteAsset={() => deleteLandingPage(landingPage)}
                            editAsset={() => editLandingPage(landingPage)}
                        />)}
                    </div>
                </CollapsibleSection>
            }
            {
                !isSearching && <CollapsibleSection
                    title={`All Landing Pages (${landingPages.length})`}
                    initiallyExpanded={true}
                >
                    <div className="asset-grid" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {landingPages.map((landingPage) => <AssetTile
                            key={landingPage.id}
                            asset={landingPage}
                            editable={landingPage.is_editable || false}
                            deletable={landingPage.can_delete || false}
                            legacy={false}
                            selectAsset={() => selectLandingPage(landingPage)}
                            deleteAsset={() => deleteLandingPage(landingPage)}
                            editAsset={() => editLandingPage(landingPage)}
                        />)}
                    </div>
                </CollapsibleSection>
            }
        </div>
    );
}

LandingPagePicker.propTypes = {
    landingPages: PropTypes.array.isRequired,
    selectLandingPage: PropTypes.func,
    deleteLandingPage: PropTypes.func,
    editLandingPage: PropTypes.func,
};

export default LandingPagePicker;
